import {
  createRouter,
  createWebHistory,
} from 'vue-router';

import {
  ERouteName,
} from './route-name';
import {
  routes,
} from './routes';

import {
  keycloakAuthenticationHandler,
} from '@/authentication.ts';
import {
  isPlaygroundEnabled,
} from '@/playground/playground.ts';
import {
  useAppStore,
} from '@/store/pinia/app';

if (isPlaygroundEnabled()) {
  routes.push({
    name: ERouteName.PLAYGROUND,
    path: '/playground',
    component: () => import('@/playground/playground.vue'),
  });
}

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

router.beforeEach(() => {
  const appStore = useAppStore();
  appStore.isNavigating = true;
});

router.afterEach(() => {
  const appStore = useAppStore();
  appStore.isNavigating = false;
});
keycloakAuthenticationHandler.addRouterMiddleware(router);

export default router;
